// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"tS-z","inlineTitle":"uS-z","sponsoredAdsWrapper":"vS-z","marketplaceRecosWrapper":"wS-z"};